(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/play/assets/javascripts/views/package-rows-container.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/play/assets/javascripts/views/package-rows-container.js');

'use strict';

svs.eurojackpot.components.play.views.PackageRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-sm-h-1 padding-md-bottom-0 padding-md-h-2',
  regions: {
    sizePickerRegion: '#sizePickerRegion',
    packageRowsRegion: '#packageRowsRegion',
    packageHuxfluxRegion: '#packageHuxfluxRegion'
  },
  template(data) {
    return svs.eurojackpot.components.play.templates.package_rows_container(data);
  },
  onRender() {
    this.showChildView('sizePickerRegion', new svs.numbergames.game.views.SizePicker({
      model: this.model,
      invertButtons: true
    }));
    this.showChildView('packageRowsRegion', new svs.numbergames.game.views.PackageRows({
      model: this.model,
      className: 'package-rows package-rows-eurojackpot grid-row padding-top-1'
    }));
    this.showChildView('packageHuxfluxRegion', new svs.numbergames.game.views.PackageHuxfluxButton({
      model: this.model
    }));
  }
});

 })(window);